export enum GameEvent {
    preloaderStart = 'preloaderStart',
    preloaderAbort = 'preloaderAbort',
    preloaderComplete = 'preloaderComplete',
    sceneOpen = 'sceneOpen',
    popupOpen = 'popupOpen',
    sceneButtonClick = 'sceneButtonClick',
    popupButtonClick = 'popupButtonClick',
    rewardButtonClick = 'rewardButtonClick',
    scroll = 'scroll',
    boosterButtonClick = 'boosterButtonClick',
    boosterUse = 'boosterUse',
    levelStart = 'levelStart',
    levelContinue = 'levelContinue',
    levelComplete = 'levelComplete',
    levelAbort = 'levelAbort',
    trigger = 'trigger',
    tutorialStart = 'tutorialStart',
    tutorialComplete = 'tutorialComplete',
    tutorialPopupOpen = 'tutorialPopupOpen',
    tutorialButtonClick = 'tutorialButtonClick',
    tutorialBoosterUse = 'tutorialBoosterUse',
    adStart = 'adStart',
    adComplete = 'adComplete',
    adAbort = 'adAbort',
    interstitialStart = 'interstitialStart',
    interstitialAbort = 'interstitialAbort',
    interstitialComplete = 'interstitialComplete',
    storeOpen = 'storeOpen',
    storeButtonClick = 'storeButtonClick',
    storeExit = 'storeExit',
    makePurchase = 'makePurchase',
    progressBarTutorialStart = 'progressBarTutorialStart',
    progressBarTutorialButtonClick = 'progressBarTutorialButtonClick',
    progressBarTutorialComplete = 'progressBarTutorialComplete',
    dailyReward = 'dailyReward',
}

export interface GameEventSceneOpen {
    sceneName: string;
    levelName?: string;
}

export interface GameEventPopupOpen {
    sceneName: string;
    popupName: string;
}

export interface GameEventSceneButtonClick {
    sceneName: string;
    buttonName: string;
    status?: boolean;
}

export enum GameEventPopupName {
    settings = 'Settings',
    youReward = 'You Reward',
    myCollection = 'My Collection',
    flowers = 'Flowers',
    forestAnimals = 'Forest Animals',
    nature = 'Nature',
    winter = 'Winter',
    exit = 'Exit',
    unlock = 'Unlock',
    dailyPrize = 'dailyPrize',
    ftueWelcome = 'FTUE Welcome'
}

export enum GameEventPopupButtonName {
    thanks = 'Thanks',
    close = 'Close',
    sound = 'Sound',
    music = 'Music',
    myCollection = 'My Collection',
    flowers = 'Flowers',
    forestAnimals = 'Forest Animals',
    nature = 'Nature',
    winter = 'Winter',
    viewAds = 'View Ads',
    buy = 'Buy',
    cancel = 'Cancel',
    exit = 'Exit',
    skip = 'Skip',
    next = 'Next',
    ftue1 = 'Flamingo',
    ftue2 = 'Sunset',
    ftue3 = 'Mountains',
    claim = 'claim',
    collect = 'collect',
    collect_x2 = 'collect_x2',
}

export enum GameEventPreloaderAbortCause {
    webGL= 'WebGL Error',
    forcedExit = 'Forced Exit',
    readError = 'Read Error',
    disconnect = 'Disconnect',
    levelExit = 'Level Exit',
}

export interface GameEventPopupButtonClick {
    sceneName: string;
    popupName: string;
    buttonName: string;
}

export interface GameEventRewardButtonClick {
    sceneName?: string;
    delay?: number;
    goal: number;
    reactionTime: number;
}

export interface GameEventProgressBarTutorialStart {
    delay: number;
}

export interface GameEventProgressBarTutorialButtonClick {
    buttonName: string;
    delay: number;
}

export interface GameEventProgressBarTutorialComplete {
    delay: number;
}

export interface GameEventScrollClick {
    sceneName: string;
    popupName: string;
}

export interface GameEventBoosterUse {
    boosterName: string;
    delay?: number;
    levelName: string;
    levelSize: number;
}

export enum GameEventSceneName {
    unknown = 'Unknown',
    lobby = 'Lobby',
    gameplay = 'Gameplay',
    endScreen = 'End Screen',
    catalog = 'Catalog'
}

export interface GameEventLevelStart {
    levelName: GameEventSceneName;
    levelSize: number;
    boosters: { needle: number; yarn: number, bucket: number; }
    percentage: number;
}

export interface GameEventLevelComplete {
    levelName: string;
    levelSize: number;
    delay: any;
    boosters: { needle: number; yarn: number; }
    stitchCount: number;
    dragCount: number;
    needleCount: number;
    yarnCount: number;
    bucketCount: number;
    zoomInCount: number;
    zoomOutCount: number;
    storeCount: number;
    rewardsCount: number;
}

export interface GameEventDelay {
    delay?: any
}

export interface GameEventLevelAbort {
    levelName: string;
    levelSize: number;
    delay?: number;
    boosters: { needle: number; yarn: number; }
    stitchCount: number;
    dragCount: number;
    needleCount: number;
    yarnCount: number;
    bucketCount: number;
    zoomInCount: number;
    zoomOutCount: number;
    storeCount: number;
    percentage: number;
    rewardsCount: number;
}

export interface GameEventTutorialPopupOpen {
    popupName: string;
}

export interface GameEventTutorialButtonClick {
    popupName: string;
    buttonName: string;
    delay: number;
}

export interface GameEventTutorialBoosterUse {
    boosterName: string;
}

export interface GameEventTutorialComplete {
    delay: string;
    stitchCount: number;
    dragCount: number;
    zoomInCount: number;
    zoomOutCount: number;
}

export interface GameEventAdAbort {
    id: string;
    time: number;
    popupName?: string;
    sceneName?: string;
    cause?: 'Force Exited' | 'Read Error' | 'Disconnect' | 'Level Exit' | 'SDK Error'
    message?: string;
}

export interface GameEventAdStart {
    id: string;
    time: number;
    popupName?: string;
    sceneName?: string;
}

export interface GameEventAdComplete {
    id: string;
    time: number;
    skip: boolean;
    popupName?: string;
    sceneName?: string;
    delay?: number;
}

export interface GameEventStoreOpen {
    delay: number;
    needleCount: number;
    yarnCount: number;
    bucketCount: number;
    triggered: boolean;
    channel: string;
}

export interface GameEventStoreButtonClick {
    buttonName: string;
    status: boolean;
    delay: number;
}

export interface GameEventStoreExit {
    delay: number;
    channel: string;
    actionsCount: number;
    itemsCount: number;
}
